<template>
	<div class="webshop-free-delivery-bar cart_info_total_extra_shipping_to_free_box" v-show="toFree?.amount != 0">
		<div class="ww-preview-note sc-preview-note cart_info_total_extra_shipping_to_free_box">
			<div class="webshop-free-delivery"><BaseCmsLabel code="min_total_missing" tag="span" /> <strong class="w-missing-shipping-value cart_info_total_extra_shipping_to_free"><BaseUtilsFormatCurrency :price="toFree.amount" /></strong></div>
		</div>
		<div class="free-delivery-missing sc-free-delivery-missing cart_info_total_extra_shipping_to_free_box">
			<div class="free-delivery-missing-bg-cnt">
				<span class="free-delivery-missing-bg cart_info_total_extra_shipping_to_free_percent" :style="'width: '+ toFree.percent"></span>
			</div>
			<span class="free-delivery-missing-overlay"></span>
		</div>
	</div>
	<div v-show="toFree?.amount != 0" class="ww-preview-free-delivery cart_info_total_extra_shipping_to_free_box" v-html="labels.get('free_delivery_widget_note').replace('%FREE_ABOVE%', formatCurrency(toFree.above))"></div>
	<div class="delivery-deadline-cart">{{labels.get('delivery_deadline')}}</div>
</template>

<script setup>
	const labels = useLabels();
	const {formatCurrency} = useCurrency();
	const props = defineProps(['toFree']);
</script>

<style lang="less" scoped>
	.webshop-free-delivery{
		font-size: 16px; line-height: 22px; text-align: center; padding-top: 0; position: relative; padding-bottom: 11px; font-weight: 300;
		:deep(strong){color: var(--primaryColor); font-weight: 500;}
		@media (max-width: @t){font-size: 15px; line-height: 22px; padding-bottom: 8px;}
		@media (max-width: @m){font-size: 14px; line-height: 20px; padding-bottom: 8px;}
	}
	.w-missing-shipping-value{color: var(--primaryColor); font-weight: bold;}
	.ww-preview-free-delivery{
		font-size: 16px; line-height: 22px; text-align: center; margin-top: 10px; font-weight: 300;
		:deep(span){font-style: initial; color: var(--primaryColor); font-weight: 500;}
		@media (max-width: @t){font-size: 15px; line-height: 22px; margin-top: 8px;}
		@media (max-width: @m){font-size: 14px; line-height: 20px; margin-top: 8px;}
	}
</style>